import { NavLink, useParams } from "react-router-dom";
import { Button, Grid, Typography } from "@mui/material";
import { AddCircle as AddCircleIcon } from "@mui/icons-material";
import * as L from "leaflet";
import { useTranslation } from "react-i18next";

import { Pane } from "src/components/Pane";
import { IsEnabled } from "src/components/permissions";
import { useScenario } from "src/hooks/useScenario";
import { useResidentialZones } from "src/hooks/residential-zones";
import { ResidentialZoneList } from "src/components/ResidentialZoneList";

interface Props {
  map: L.Map;
}

export function ResidentialZonesPage(props: Props) {
  const { t } = useTranslation();
  const { caseId = "", scenarioId = ""} = useParams<{
    caseId: string;
    scenarioId: string;
  }>();
  const { data: scenario } = useScenario(scenarioId);
  const { data: residentialZones } = useResidentialZones(scenarioId);

  return render();

  function render() {
    if (!scenario || !residentialZones) return null;

    return (
      <>
        <Pane>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h2">{t("label.residentialZones")}</Typography>
            </Grid>

            <ResidentialZoneList data={residentialZones} scenario={scenario} />

            <IsEnabled permission={scenario.permissions.updateResidential}>
              <Grid item xs={12}>
                <Button
                  startIcon={<AddCircleIcon />}
                  color="primary"
                  component={NavLink}
                  size="small"
                  to={`/cases/${caseId}/scenarios/${scenarioId}/residential-zones/new`}
                >
                  {t("label.addResidentialZone")}
                </Button>
              </Grid>
            </IsEnabled>
          </Grid>
        </Pane>
      </>
    );
  }
}
